import { create } from "zustand";
import axios from "axios";
import { URL } from "../lib/apis";

// Define the state and actions in the store
interface FruitState {
  fruits: string[]; // Array to store all fruits
  filteredFruits: string[]; // Array for the filtered search results
  loadingAllFruit: boolean; // Loading state for fetching fruits
  error: string | null; // Error state for any failed requests
  fetchAllFruit: () => Promise<void>; // Action to fetch all fruits
  searchFruits: (query: string) => void; // Action to filter fruits by search query
}

// Zustand store
const useFruitStore = create<FruitState>((set, get) => ({
  fruits: [], // Initialize with an empty array
  filteredFruits: [], // Initialize with an empty array
  loadingAllFruit: false, // No loading initially
  error: null, // No error initially

  // Action to fetch all fruits from an API
  fetchAllFruit: async () => {
    set({ loadingAllFruit: true, error: null }); // Set loading to true
    try {
      const response = await axios.get(
        `${URL}/products`
      );
      const fruits = response.data.products; // Adjust to match your API response structure
      set({ fruits, filteredFruits: fruits, loadingAllFruit: false }); // Set both fruits and filteredFruits
    } catch (error) {
      set({ error: "Failed to fetch fruits", loadingAllFruit: false }); // Set error if request fails
    }
  },

  // Action to filter fruits based on search query
  // Action to filter fruits based on search query
  searchFruits: (query: string) => {
    const { fruits } = get();
    const filteredFruits = fruits.filter((fruit: any) =>
      fruit.product_name.toLowerCase().includes(query.toLowerCase())
    );
    set({ filteredFruits });
  },
}));

export default useFruitStore;
